import { render, staticRenderFns } from "./SalesProjects.vue?vue&type=template&id=90a32bf2&scoped=true&"
import script from "./SalesProjects.vue?vue&type=script&lang=ts&"
export * from "./SalesProjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a32bf2",
  null
  
)

export default component.exports